export default __webpack_public_path__ + "static/app-store-fd44cc0e85d71c05121ca8b8e78841ab.png";